import { getMethod, postMethod } from '@/services/apis/http-server';
import fetchClient from '@/services/apis/common';
export const getTags = async (params: any) => {
  try {
    const response = await getMethod('client/tags', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};

export const getChartTop = async (params: any) => {
  try {
    const response = await getMethod('client/tags/chart-top', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};

export const registerAPI = async (params: Record<string, string>) => {
  try {
    const response = await postMethod('public/register/api', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};

export const getBase64File = async (key: string) => {
  try {
    const response = await getMethod(
      'public/v2/' + key,
      {},
      {
        headers: {
          'file-api-key': process.env.NEXT_PUBLIC_SECRET_FILE || '',
        },
      },
    );
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};
